import React, { FC } from 'react';
import TSPriorityDisplay from './TSPriorityDisplay';
import OWTag from '../../common/OWTag';

const TSPrioritiesDisplay: FC<any> = ({ priorities = [], notSpecified }) => {
	return (
		<div className="flex flex-row flex-wrap items-center gap-2">
			{priorities.length > 0 ? (
				priorities.map((p, idx) => <TSPriorityDisplay key={`ts-priority-${idx}`} priority={p} />)
			) : (
				<>
					<OWTag>{notSpecified ? 'Not Specified' : 'All Priorities'}</OWTag>
				</>
			)}
		</div>
	);
};

export default TSPrioritiesDisplay;
